import { Cart } from 'types/cart.types';
import styles from './CheckoutOrderDetails.module.scss';
import cn from 'classnames';
import { useCurrencyFormatter } from '@hooks/useCurrencyFormatter';
import { useMonthsYearsFormatter } from '@hooks/useMonthsYearsFormatter';
import { usePhrases } from '@hooks/context/usePhrases';
import { Order } from 'types/order.types';

interface CheckoutOrderDetailsProps {
  cart: Cart;
  order: Order;
}

// TODO Targo: it should be a separated component
// Should be added in stroy block (especially in first and confirmation finance checkout page)
export const CheckoutOrderDetails = ({ cart, order }: Partial<CheckoutOrderDetailsProps>) => {
  const { currencyFormatter } = useCurrencyFormatter();
  const { monthsYearsFormatter } = useMonthsYearsFormatter();
  const phrases = usePhrases({ name: 'checkout-finance-offer-details' });

  // Funding period is the same for all items in the cart
  const fundingPeriod = cart?.items?.[0]?.pricing?.months || order?.financeContract?.loanPeriod;
  const formattedFundingPeriod = monthsYearsFormatter({ monthsValue: fundingPeriod });

  const totalMonthlyPrice = cart?.totalMonthlyPrice || order?.items?.reduce((total, item) => total + item.price, 0);

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{phrases['title']}</h2>
      <p className={styles.text}>
        {phrases['number-of-products-items']}: {cart?.items.length || order?.items?.length}
      </p>

      <p className={styles.text}>{phrases['subtitle']}:</p>

      <div className={cn(styles.offerDetails, styles.offerDetailsHeader)}>
        <p>{phrases['monthly-finance-rate']}</p>
        <p>
          {currencyFormatter({
            price: totalMonthlyPrice,
          })}
        </p>
      </div>

      <div className={styles.offerDetails}>
        <p>{phrases['funding-period']}:</p>
        <p>{formattedFundingPeriod}</p>
      </div>

      <div className={styles.offerDetails}>
        <p>{phrases['interest-fee']}:</p>
        <p>{currencyFormatter({ price: 0 })}</p>
      </div>

      <div className={styles.offerDetails}>
        <p>{phrases['total-amount-after']?.replace('{time}', formattedFundingPeriod)}:</p>
        <p>{currencyFormatter({ price: totalMonthlyPrice * fundingPeriod })}</p>
      </div>
    </div>
  );
};

export default CheckoutOrderDetails;
